"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionalCreditCheckSchema = void 0;
var consumer_declaration_schema_1 = require("./consumer-declaration-schema");
exports.transactionalCreditCheckSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'cmhcAccountNumber',
        'applicationIDTimestamp',
        'typeID',
        'creditAgencyID',
        'beaconScoreRejectReasonTypeCode',
        'bankruptcyIndicator',
        'canadianIncomePredictorScoreRejectReasonCode',
        'canadianIncomePredictorScoreNumber',
        'creditCheckResultTypeCode',
        'creditScoreReasonTypeCode1',
        'creditScoreReasonTypeCode2',
        'creditScoreReasonTypeCode3',
        'creditScoreReasonTypeCode4',
        'creditAgencyBorrowerID',
        'creditAgencyHitTypeCode',
        'creditBureauRequestedIndicator',
        'empiricaCreditScoreNumber',
        'empiricaRejectReasonCode',
        'fictitiousIdentityMatchIndicator',
        'geographicMitigatingActionCreditScorePoints',
        'geographicMitigatingActionReasonTypeCode1',
        'geographicMitigatingActionReasonTypeCode2',
        'geographicMitigatingActionReasonTypeCode3',
        'geographicMitigatingActionReasonTypeCode4',
        'genericCreditScoreCount',
        'multipleCreditReportIndicator',
        'cmhcOfficeID',
        'primaryCreditBureauResultIndicator',
        'quebecJudgmentIndicator',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'safeScanTypeCode',
        'thinFileIndicator',
    ],
    properties: {
        cmhcAccountNumber: {
            type: 'number',
            minimum: 0,
            maximum: 999999999999,
            errorMessage: 'should be a number with up to 12 digits',
        },
        applicationIDTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        typeID: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        creditAgencyID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        activeTradeTwelveMonthCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        beaconScoreRejectReasonTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        bankruptcyDischargeDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        bankruptcyIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        canadianIncomePredictorScoreRejectReasonCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        canadianIncomePredictorScoreNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        creditCheckResultTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        creditAgencyCurrentInquiriesCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        creditScoreReasonTypeCode1: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        creditScoreReasonTypeCode2: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        creditScoreReasonTypeCode3: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        creditScoreReasonTypeCode4: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        creditAgencyTotalInquiriesCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        creditAgencyBorrowerID: {
            type: 'string',
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
        },
        creditAgencyHitTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        creditBureauRequestedIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        creditFileCreateDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        empiricaCreditScoreNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        empiricaRejectReasonCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        fictitiousIdentityMatchIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        firstTradeSinceBackReportDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        firstTradeOpenDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        geographicMitigatingActionCreditScorePoints: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        geographicMitigatingActionReasonTypeCode1: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        geographicMitigatingActionReasonTypeCode2: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        geographicMitigatingActionReasonTypeCode3: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        geographicMitigatingActionReasonTypeCode4: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        genericCreditScoreCount: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        helocTradesCreditLimitAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        helocTradesOutstandingBalanceAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        pastTwelveMonthActiveInstallmentTradeCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        lastUnfavourableCreditRatingPeriod: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters or null',
        },
        mostRecentCollectionDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        judgmentDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        mortgageTradesOutstandingBalanceLastTwelveMonthAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        mortgageOrHelocTradeWorstLastTwelveMonthCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        mortgageOrHelocWorstRatingCodeDeprecated: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        multipleCreditReportIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        cmhcOfficeID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        totalOpenInstalmentTradeCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        openRevolvingTradeCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        openTradeInLastTwelveMonthCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        openTradeCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        publicRecordDelinquentCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        primaryCreditBureauResultIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        quebecJudgmentIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        revolvingDebtBurdenAmount: {
            type: ['number', 'null'],
            maximum: 999,
            minimum: 0,
            multipleOf: 0.00009999999999999999,
            errorMessage: 'should be a decimal with up to 7 digits in total and 4 digits of precision or null',
        },
        revolvingTradeActiveTwelveMonthCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        safeScanTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        thinFileIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        totalCollectionsCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648 or null',
        },
        totalJudgmentCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        totalMonthlyPaymentPastDueAmount: {
            type: ['number', 'null'],
            maximum: 9999999999999,
            minimum: 0,
            multipleOf: 0.01,
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision or null',
        },
        worstFirstTradePastDueCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        worstFirstTradePastDueDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        worstCurrentCreditRatingCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        worstEverCreditRatingCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        consumerDeclaration: consumer_declaration_schema_1.consumerDeclarationSchema,
    },
};
